module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "Paragraph-Style-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "src": "image/2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-DropCap-_FBM"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("W")]), _vm._v("hen we were working on the Random Acts of Kindness campaign, it was an incredibly joy-filled experience. Our work was not just about helping the company or paying rent for the month—it suddenly really meant something. We were making the world a better place, one act of kindness at a time. There was electricity in the air, and we arrived at work each day to see what miracles had happened overnight while we were"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("sleeping.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("One day we knew everything had really changed, via the US postal service. Usually we only had a dozen or so pieces of mail: bills mostly, a few queries, letters from readers, or an order or two. One day, the mailman knocked and said, “I need help here!” He had "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("bags")]), _vm._v(" of letters from people all over the country, many with suggestions of acts of kindness. There were tears of laughter as we sat down on the floor and tore open the envelopes, reading aloud from the letters. Some were in children’s big blocky letters (these usually had the best ideas of kindness) and others in elders’ careful script. We still treasure those memories of seeing the power of the human heart"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" that")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("In a time when so many people feel powerless and unrecognized, when miserable things happen to wonderful people, there are moments when we must stomp our feet in indignation and outrage. But to balance all that, it’s important to remember all those people who have sustained our souls and remember that each of us is the culmination of an infinite number of improbable gifts from myriad nameless sources. Practicing random acts of kindness cracks the tough shell that begins to grow around our hearts each time we watch the news or experience another’s suffering. The circumference of who we are begins to swell full and ripe, and a longing to reach, to risk what can be possible"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(", sprouts.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Signature _idGenParaOverride-1"
  }, [_vm._v("Brenda Knight and Daw"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("na")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Markova")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0f8a88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomActsKindness-4.vue
// module id = 72
// module chunks = 0